/* eslint-disable */

$(".js-half-image-slider").each(function (index) {
    var container = $(this),
        slider = container.find(".js-text-slider"),
        progress_bar_label = container.find(".js-slider-label"),
        prev_arrow = container.find(".js-text-prev-arrow"),
        next_arrow = container.find(".js-text-next-arrow");

    slider.slick({
        slidesToShow: 1,
        arrows: true,
        dots: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 13000,
        cssEase: "linear",
        prevArrow: prev_arrow,
        nextArrow: next_arrow,
    });

    var time = 9;
    var $bar, isPause, tick, percentTime;

    $bar = container.find(".js-slider-progress");

    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        isPause = false;
        tick = setInterval(interval, 10);
    }

    function interval() {
        if (isPause === false) {
            percentTime += 1 / (time + 0.1);
            $bar.css({
                width: percentTime + "%",
            });
            if (percentTime >= 100) {
                slider.slick("slickNext");
                startProgressbar();
            }
        }
    }

    function resetProgressbar() {
        $bar.css({
            width: 0 + "%",
        });
        clearTimeout(tick);
    }

    startProgressbar();

    slider.on("beforeChange", function () {
        resetProgressbar();
        startProgressbar();
        $bar.css({
            width: 100 + "%",
        });
    });
});



// WEBPACK FOOTER //
// ./scripts/partials/half-image-half-slider.js